import { store } from 'setup/store';

export const useAccessActions = () => {
  const hasAccess = (accessKey: string) => {
    const accessList = store.getState().sessionReducer.accessList;
    const access = accessList?.find((acc) => acc.accessKey === accessKey);
    return access ? true : false;
  };

  return {
    hasAccess,
  };
};
